const { get, memoize, createInvariantWithPrefix } = require('./library');

module.exports = {
  get,
  memoize,
  createInvariantWithPrefix,
};
